<template>
    <button v-if="buttonStyle == 'normal'" type="button" :disabled="isReadonly == false || isReadonly == 'false'" @click="$emit('click')" :class="switchClass()"><i class="" :class="switchIcon()"></i><span class="text-white font-weight-500 font-base mb-0">{{text}}</span></button>
    <button v-else-if="buttonStyle == 'icon'" type="button" :disabled="isReadonly == false || isReadonly == 'false'" @click="$emit('click')" :class="switchClass()"><feather :type="switchIcon()" style="height: 14px;"></feather><span :class="switchSpan()">{{text}}</span></button>
</template>

<script>
    export default {
        name: 'SubmitButton',
        props: {
            'text': String,
            'type': String,
            'buttonStyle': String,
            // 'isReadonly': Boolean
            'isReadonly': String
        },
        mounted() {
            console.log(this.type);
            console.log(this.buttonStyle);
        },
        methods: {
            switchClass() {
                switch(this.type) {
                    case 'sm-primary': 
                        return 'btn btn-primary btn-sm'
                    case 'btn-dark':
                        return 'btn btn-dark btn-block accred-button'
                    case 'View':
                        return 'btn btn-outline-secondary btn-md'
                    case 'Schedule':
                        return 'btn btn-outline-secondary btn-md'
                    case 'Edit':
                        return 'btn btn-outline-secondary btn-md'
                    case 'Create':
                        return 'btn btn-dark btn-md'
                    default:
                        return 'button button-secondary button-xl button-md form-control text-white font-weight-500'
                }
            },
            switchIcon () {
                switch (this.type) {
                    case 'icon':
                        return 'mdi mdi-plus'
                    case 'btn-dark':
                        return 'ti-file btn-icon-append p-2'
                    case 'View':
                        return 'eye'
                    case 'Schedule':
                        return 'calendar'
                    case 'Edit':
                        return 'edit-2'
                    case 'Create':
                        return 'edit-2'
                    default:
                        return ''
                    }
            },
            switchSpan () {
                switch (this.type) {
                    case 'View':
                        return 'font-base mx-2'
                    case 'Schedule':
                        return 'font-base mx-2'
                    case 'Edit':
                        return 'font-base mx-2'
                    case 'Create':
                        return 'font-base mx-2'
                    default:
                        return 'text-white font-weight-500 font-base mb-0'
                    }
            }
        }
    }
</script>